import TableLingvoAnylize from "./TableLingvoAnylize"; // Основной компонент

export default TableLingvoAnylize; // Экспорт по умолчанию
